import { render } from "./UpdateVouchers.vue?vue&type=template&id=006f9138"
import script from "./UpdateVouchers.vue?vue&type=script&lang=js"
export * from "./UpdateVouchers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__